export default __webpack_public_path__ + "static/media/doctor-task.2827972e.svg";